import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { PageHeaderComponent, PageInfoComponent, PageSubtitleComponent, PageTitleComponent } from './page-header.component';
import { ComponentsModule } from '@carelinelive/ui';


@NgModule({
    declarations: [
        PageHeaderComponent,
        PageTitleComponent,
        PageSubtitleComponent,
        PageInfoComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        ComponentsModule
    ],
    exports: [
        PageHeaderComponent,
        PageTitleComponent,
        PageSubtitleComponent,
        PageInfoComponent
    ]
})
export class PageHeaderModule {
}
